<template>
  <section class="growth-path">
    <div class="container">
      <h2 class="section-title">{{ $t('student.growthTitle') }}</h2>
      <p class="section-subtitle">{{ $t('student.growthDesc') }}</p>
      
      <div class="path-flow">
        <div class="path-stage">
          <div class="stage-icon">
            <span class="icon-number">1</span>
          </div>
          <h3>{{ $t('usage.studentStep1') }}</h3>
          <p>{{ $t('usage.studentStep1Desc') }}</p>
        </div>

        <div class="path-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2"/>
          </svg>
        </div>

        <div class="path-stage">
          <div class="stage-icon">
            <span class="icon-number">2</span>
          </div>
          <h3>{{ $t('usage.studentStep2') }}</h3>
          <p>{{ $t('usage.studentStep2Desc') }}</p>
        </div>

        <div class="path-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2"/>
          </svg>
        </div>

        <div class="path-stage">
          <div class="stage-icon">
            <span class="icon-number">3</span>
          </div>
          <h3>{{ $t('usage.studentStep3') }}</h3>
          <p>{{ $t('usage.studentStep3Desc') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GrowthPathFlow'
}
</script>

<style scoped>
.growth-path {
  padding: 5rem 2rem;
  background: #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.path-flow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  align-items: center;
}

.path-stage {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.path-stage:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.stage-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(0, 217, 255, 0.4);
}

.icon-number {
  font-size: 1.8rem;
  font-weight: 800;
  color: #020617;
}

.path-stage h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 0.5rem;
}

.path-stage p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.6;
}

.path-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00D9FF;
}

.path-arrow svg {
  width: 24px;
  height: 24px;
}

@media (max-width: 1024px) {
  .path-flow {
    grid-template-columns: 1fr;
  }

  .path-arrow {
    display: none;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .growth-path {
    padding: 3rem 1.5rem;
  }
}
</style>
